import './search.scss';

import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

export class Search extends React.Component {

  constructor(props) {
    super(props);
    this.clear = (e) => {
      this.refs.query.value="";
      this.refs.query.focus();
    };

    this.clearOnEsc = (e) => {
      if (e.which === 27) {
        this.clear();
      }
    };

    this.submitQuery = this.submitQuery.bind(this);
    this.focusInput = this.focusInput.bind(this);
  }

  componentDidMount() {
    window.addEventListener('keydown', this.focusInput);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.focusInput);
  }

  focusInput(e) {
    if ((e.ctrlKey || e.metaKey) && e.keyCode === 83) {
      e.preventDefault();
      this.refs.query.select();
    }
  }

  submitQuery(e) {
    e.preventDefault();
    console.log('submit');
    const val = this.refs.query.value;
    if (!val) {
      return;
    }
    this.props.search(val);
    this.refs.query.focus();
  }

  render() {
    let query = "";
    if (this.props.query.q) {
      query = this.props.query.q;
    }
    return (
      <div className="toolbar-search">
        <form onSubmit={this.submitQuery}>
          <span
            className="search-clear"
            onClick={this.clear}>&times;</span>
          <input
            ref="query"
            name="q"
            type="text"
            className="c-input"
            onKeyDown={this.clearOnEsc}
            defaultValue={query}
            placeholder="Search for images here..."
            autoFocus
            autoComplete="off" />
          <button
            type="submit"
            className="search-start">
            <i className="fa fa-search" />
          </button>
        </form>
      </div>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  search: (query) => {
    dispatch(push({
      pathname: '/search',
      query: {
        q: query
      }
    }));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Search);



/** WEBPACK FOOTER **
 ** ./components/search/index.js
 **/